module.exports = __webpack_public_path__ + "static/media/TheBills.fdd96966.webp";